/* eslint-disable @typescript-eslint/no-unused-vars */
import { PriceCardFileGateway } from '@price-card/gateways/price-card-file.gateway';
import { FileDownloader } from '@price-card/providers/file-downloader.provider';
import { formatGetHeaders } from '@configurations/api-configuration';
import { environment } from '../../../../../environments/environment';

export class ApiPriceCardFileGateway implements PriceCardFileGateway {
  private readonly priceCardFileApiUrl = `${environment.backend_url}/api/v1/price-card`;

  constructor(private readonly fileDownloader: FileDownloader) {}

  async retrieveByPriceZoneAndTechnologyAndCommercialOperationDate(
    priceZoneId: number,
    technologyId: number,
    commercialOperationDateIds: number[],
  ): Promise<void> {
      const URL = `${this.priceCardFileApiUrl}?priceZoneId=${priceZoneId}&technologyId=${technologyId}&commercialOperationDateIds=${commercialOperationDateIds.join(',')}`;
      const response: Response = await fetch(URL, await formatGetHeaders());

      if(response.status !== 200){
        throw new Error('Error retrieving price card file: ' + response.statusText);
      }

      const filename = this.retrieveFilenameFromResponse(response);
      this.fileDownloader.handle(await response.blob(), filename);
  }

  retrieveFilenameFromResponse(response: Response): string {
    const disposition = response.headers.get('Content-Disposition');
    let filename = 'price-card.xlsx'; // valeur par défaut

    if (disposition?.includes('filename=')) {
      const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
      if (match?.[1]) {
        filename = match[1].replaceAll(/['"]/g, '');
      }
    }
    return filename;
  }
}
